module.exports = __webpack_public_path__ + "static/img/image_solutions_intellgent_03.be72cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_intellgent_03.png
// module id = z3wT
// module chunks = 10